<template>
  <div>
    <van-cell-group title="节目">
      <van-cell
        title="播放记录"
        icon="todo-list-o"
        is-link
        @click="playHistory"
      />
      <van-cell
        title="我购买的私房课"
        icon="gem-o"
        is-link
        @click="purchase"
      />
    </van-cell-group>
    <van-cell-group title="礼品卡">
      <van-cell
        title="我购买的礼品卡"
        icon="gift-o"
        is-link
        @click="giftCardsMine"
      />
      <van-cell
        title="我收到的礼品卡"
        icon="gift-card-o"
        is-link
        @click="giftCardsToMe"
      />
    </van-cell-group>
    <van-cell-group title="兑换券" v-if="voucherConfig.enable">
      <van-cell
        title="我的兑换券"
        icon="coupon-o"
        is-link
        @click="vouchers"
      />
      <!-- <van-cell
        title="已兑换私房课"
        icon="gem-o"
        is-link
        @click="redeemed"
      /> -->
    </van-cell-group>
    <van-cell-group title="评论">
      <van-cell
        title="我写的评论"
        icon="edit"
        is-link
        @click="myComments"
      />
      <van-cell
        title="我赞过的"
        icon="good-job-o"
        is-link
        @click="iLikedComments"
      />
      <van-cell
        title="回复我的"
        icon="comment-o"
        value-class="badge"
        is-link
        @click="replyToMeComments"
      >
        <!-- <template slot="right-icon">
          <span class="badge"><van-tag type="danger">3</van-tag></span>
        </template> -->
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Cell, CellGroup } from 'vant'
  import { Toast } from 'vant'
  Vue.use(Cell).use(CellGroup)
  Vue.use(Toast)

  export default {
    props: {
    },
    data () {
      return {
        slug: this.$route.params.slug,
        voucherConfig: {
          enable: false
        }
      }
    },
    components: {
    },
    methods: {
      playHistory () {
        this.$router.replace({
          name: `PersonalHistory`,
          params: {
            slug: this.slug
          }
        })
      },
      purchase () {
        this.$router.replace({
          name: `PersonalPurchase`,
          params: {
            slug: this.slug
          }
        })
      },
      giftCardsMine () {
        this.$router.replace({
          name: `PersonalGiftCardsMine`,
          params: {
            slug: this.slug
          }
        })
      },
      giftCardsToMe () {
        this.$router.replace({
          name: `PersonalGiftCardsToMe`,
          params: {
            slug: this.slug
          }
        })
      },
      vouchers: function () {
        this.$router.replace({
          name: 'PersonalVouchers',
          params: {
            slug: this.slug
          }
        })
      },
      redeemed: function () {
        this.$router.replace({
          name: 'PersonalRedeemed',
          params: {
            slug: this.slug
          }
        })
      },
      myComments () {
        this.$router.replace({
          name: `PersonalMyComments`,
          params: {
            slug: this.slug
          }
        })
      },
      iLikedComments () {
        this.$router.replace({
          name: `PersonalILikedComments`,
          params: {
            slug: this.slug
          }
        })
      },
      replyToMeComments () {
        this.$router.replace({
          name: `PersonalReplyToMeComments`,
          params: {
            slug: this.slug
          }
        })
      },
      boughtEpisodeList () {
        Toast("功能开发中")
        window.console.log("boughtEpisodeList")
      },
      getVoucherConfig: function () {
        let that = this
        let params = {
          show__slug: that.slug
        }
        that.$api.voucherConfig.list(params)
        .then(res => {
          window.console.log("获取到 voucher config")
          window.console.log(res)
          if (res.data.count > 0) {
            that.voucherConfig = res.data.results[0]
          } else {
            window.console.log("未找到相关配置")
          }
        })
        .catch(err => {
          window.console.log("获取 voucher config 有误", err)
        })
      }
    },
    mounted () {
      // this.slug = this.$route.params.slug
      this.getVoucherConfig()
    }
  }
</script>

<style lang="css" scoped>
  .badge {
    margin-left: 20px;
    font-weight: bold;
  }
</style>
